import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {tap, catchError, map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SimpleEntity } from '../../models/simple-entity.model';
import { WhStockWarehouse } from '../../models/warehouse/whstock-warehouse.model';
import { BaseService } from '../base.service';


@Injectable()
export class WhProductService extends BaseService<any>{
    constructor(public httpClient: HttpClient) {
        super(
            'loads',
            httpClient);
    }

    autocomplete = this.getWhProductWithQuantity;

    getWhProductWithQuantity(params): Observable<SimpleEntity[]> {
        let uri  = new URL(environment.baseUrl + '/loads/getWhProductWithQuantity').updateQueryParam(params)
        return this.httpClient.get<SimpleEntity[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    getWhProductsByName(params): Observable<SimpleEntity[]> {
        let uri  = new URL(environment.baseUrl + '/loads/getWhProductsByName').updateQueryParam(params)
        return this.httpClient.get<SimpleEntity[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    getWhProductCodes(code): Observable<any> {
        const url = environment.baseUrl + '/loads/getWhProductCodes?code=' + code;

        return  this.httpClient.get<string[]>(url, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                map(value => value.map(v => ({name: v, id: value.indexOf(v) + 1}))),
                tap(),
                catchError(this.handleError)
            );
    }

    getWhProductBrands(): Observable<any> {
        const url = environment.baseUrl + '/loads/getWhProductBrands';

        return  this.httpClient.get<string[]>(url, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            );
    }


}
